import { t as __t } from "i18next";
const CopyrightFooter = () => {
    return (
      <div className="copyright-text">
        <p>
          © {new Date().getFullYear()} Powered by {" "}
          <a
            href="https://themeforest.net/user/ib-themes"
            target="_blank"
            rel="noopener noreferrer"
          >
            ULaoDev
          </a>
          {__t("uiText.text372")}</p>
      </div>
    );
  };
  
  export default CopyrightFooter;
  